import React, { Component } from 'react';
import update from 'immutability-helper';
import {connect} from 'react-redux'
import {Alert, Button, Col, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import fetch from 'node-fetch';
import {Link} from "react-router-dom";
import * as EmailValidator from "email-validator";
import Loading from "../components/Loading";

class TeamInvitePage extends Component {

    constructor(){
        super();

        this.state = {
            loading: false,
            form: {
                team: "",
                email: "",
                name: "",
                password: "",
                password2: "",
            },
            message: undefined,
            status: null,
        }
    }

    handleChange(event) {
        this.setState({form:
            update(this.state.form, {
                [event.target.name]: {$set: event.target.value}
            })
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.user){
            this.props.history.push("/")
        }
    }


    submitForm(){
        if(!this.state.form.team){
            this.setState({message: {type: "danger", "title": "Error", message: "Please provide a team name."}})
            return;
        }

        if(!this.state.form.name){
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter your name."}})
            return;
        }

        if(!this.state.form.email || !EmailValidator.validate(this.state.form.email)){
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid e-mail address."}})
            return;
        }

        if(this.state.form.password !== this.state.form.password2){
            this.setState({message: {type: "danger", "title": "Error", message: "The passwords were not identical."}})
            return;
        }
        if(this.state.form.password.length < 8){
            this.setState({message: {type: "danger", "title": "Error", message: "Your password is too short. It must be at least 8 characters."}});
            return;
        }

        this.setState({message: undefined, loading: true});

        const data = {
            team: this.state.form.team,
            name: this.state.form.name,
            email: this.state.form.email,
            password: this.state.form.password
        };

        fetch("https://us-central1-t-rex-b476a.cloudfunctions.net/createTeam", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        })
            .then(res => res.json())
            .then(res => {if(res.error){throw new Error(res.error)} return res})
            .then(json => json.status)
            // .then(res => {console.log("test2", res); return res})
            .then(status => this.setState({
                loading: false,
                status
            }))
            // .then(res => {console.log("test3", res); return res})
            .catch(error => {console.log(error); this.setState({
                loading: false,
                message: {type: "danger", title: "Error", message: "Something went wrong: " + error.message}
            })})
    }

    render(){

        const {message, status} = this.state;

        return (
            <div className="form-holder">

                {status && (
                    <div className="card">
                        <div className="card-heading">
                            <h1 className="card-title">
                                Success!
                            </h1>
                        </div>
                        <div className="card-body">
                            <p>Your account has been created successfully. Please verify your e-mail address by clicking on the link in the T-Rex Welcome e-mail you will receive shortly.</p>
                        </div>
                        <div className="card-footer">
                            <Link to ="/sign-in"><Button bsStyle="primary">Sign in</Button></Link>
                        </div>
                    </div>
                )}

                {!status && (
                    <div className="card">
                        <div className="card-heading">
                            <h1 className="card-title">
                                Sign Up
                                <Loading right loading={this.state.loading} />
                            </h1>
                        </div>
                        <div className="card-body">


                            {message && (
                                <Alert bsStyle={message.type} onDismiss={() => this.setState({message: null})}>
                                    <h4>{message.title}</h4>
                                    {message.message}
                                </Alert>
                            )}

                            <p>Thank you for joining T-Rex! Please enter the following details to create your account.</p>


                            <Form horizontal style={{margin: "15px"}}>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3}>
                                            Team name
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" type="text" name="team" value={this.state.form.team} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3}>
                                            Your name
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" type="text" name="name" value={this.state.form.name} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3}>
                                            E-mail address
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" type="email" name="email" value={this.state.form.email} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3}>
                                            Password
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" type="password" name="password" value={this.state.form.password} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3}>
                                            Repeat Password
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" type="password" name="password2" value={this.state.form.password2} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </div>
                        <div className="card-footer clearfix">
                            <Button bsStyle="primary" disabled={this.state.loading} className="pull-right" onClick={this.submitForm.bind(this)}>
                                Next
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(state => ({
    user: state.users.active
}), dispatch => ({
}))(TeamInvitePage);


// WEBPACK FOOTER //
// ./src/pages/NewTeamPage.js